import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'nh-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxComponent {
  @Input() control: FormControl;
  @Input() checkedValue: any;
  @Input() uncheckedValue: any = null;
  @Input() label: string;
  @Input() name: string;
  @Input() inline = false;
  @Input() disabled = false;
  @Input() mandatory = false;
  @Input() index: string;
  @Input() ariaLabel: string;
  @Input() ariaRequired: boolean = false;
  @Input() globalLangTranslate: boolean = true;
  @Input() fromCheckboxList: boolean = false;
  @Input() readonly = false;

  get isDisabled() {
    if (this.disabled) {
      return true;
    } else {
      return null;
    }
  }
   onCheckboxClick(event: MouseEvent): void {
    if (this.readonly) {
      event.preventDefault();
    }
  }
}
